import type { DashboardWidgetType } from 'src/constants/dashboard';
import type { DashboardConfig } from 'src/types/dashboard';

export const dashboardContainsWidgetTypes = (
  dashboardConfig: DashboardConfig | undefined,
  widgetList: DashboardWidgetType[],
): boolean =>
  !!dashboardConfig &&
  dashboardConfig.widgets.findIndex(({ widget_type }) =>
    widgetList.includes(widget_type),
  ) > -1;

export const activeCrossSurveyBenchmarkWidgets = (
  dashboardConfig: DashboardConfig | undefined,
): boolean =>
  !!dashboardConfig?.widgets.find((widget) => !!widget.benchmark_question);
